import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { editUserEnteredSupplement, getUserEnteredSupplementDetails } from '@api/supplements';
import { IUserEnteredSupplement } from '@interfaces/supplements';

export const handleGetUserEnteredSupplementDetails = createAsyncThunk<
  AxiosResponse<IUserEnteredSupplement>,
  { id: number }
>('getUserEnteredSupplementDetails', ({ id }) => getUserEnteredSupplementDetails(id));

export const handleEditUserEnteredSupplement = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IUserEnteredSupplement
>('editUserEnteredSupplement', editUserEnteredSupplement);
